// start:ng42.barrel
export * from './reservation-policies.component';
// end:ng42.barrel



// WEBPACK FOOTER //
// ./src/main/webapp/stay-mgmt/app/components/reservation-policies/index.ts